import apiClient from '../utils/apiClient';

export async function getCurrentUser() {
  const response = await apiClient.get('/api/employees/user');
  return response.data;
}
